export class SaasWorkloadStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workload",
            "baseName": "workload",
            "type": "SaasWorkload",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SaasBackupStatus",
            "format": ""
        },
        {
            "name": "captureOutcome",
            "baseName": "captureOutcome",
            "type": "SaasCaptureOutcome",
            "format": ""
        },
        {
            "name": "captureReason",
            "baseName": "captureReason",
            "type": "SaasCaptureReason",
            "format": ""
        },
        {
            "name": "containers",
            "baseName": "containers",
            "type": "Array<SaasContainerCapture>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasWorkloadStatus.attributeTypeMap;
    }
    constructor() {
    }
}
